var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnEndingDefaultBadge = function SvgIcnEndingDefaultBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 25V0H24V25L14 19.8864L4 25Z",
    fill: "#753BBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3343 8.04893C13.5438 7.40402 14.4562 7.40402 14.6657 8.04894L15.4144 10.3532C15.5082 10.6416 15.7769 10.8369 16.0802 10.8369H18.503C19.1811 10.8369 19.4631 11.7046 18.9145 12.1032L16.9543 13.5273C16.709 13.7056 16.6063 14.0215 16.7001 14.3099L17.4488 16.6142C17.6583 17.2591 16.9202 17.7954 16.3716 17.3968L14.4114 15.9727C14.1661 15.7944 13.8339 15.7944 13.5886 15.9727L11.6284 17.3968C11.0798 17.7954 10.3417 17.2591 10.5512 16.6142L11.2999 14.3099C11.3937 14.0215 11.291 13.7056 11.0457 13.5273L9.08553 12.1032C8.53693 11.7046 8.81888 10.8369 9.49698 10.8369H11.9198C12.2231 10.8369 12.4918 10.6416 12.5856 10.3532L13.3343 8.04893Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnEndingDefaultBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_ending_default_badge.41269f61.svg";
export { ForwardRef as ReactComponent };